import { ajaxGet, httpActions } from '@figure/frontlib-onboarding-redux';

const { baseUrl } = httpActions;
const SECURE = `${baseUrl()}/service-truework/secure/api/v1`;

export const TRUEWORK_GET_TOKENS = 'PL::TRUEWORK_GETTOKENS';

export const getTrueworkToken = () => async (dispatch) =>
  ajaxGet(TRUEWORK_GET_TOKENS, dispatch, `${SECURE}/session/create`);
